export const DOC_CONFIG_DEFAULT = {
  pageSize:       10   as 5 | 10 | 20 | 50,
  fileTypes:      []   as string[],
  parentFolderId: ''   as string,
  query:          ''   as string,
  createdAfter:   ''   as string,
  createdBefore:  ''   as string,
  updatedAfter:   ''   as string,
  updatedBefore:  ''   as string,
  createdBy:      ''   as string,
  sortField:      'created_at' as 'name' | 'created_at' | 'updated_at',
  sortDir:        'desc'       as 'asc' | 'desc',
};

export type DocConfig = typeof DOC_CONFIG_DEFAULT;

export const TASK_CONFIG_DEFAULT = {
  filterKeyword:  ''   as string,
  status:         'all' as 'all' | 'pending' | 'in_progress' | 'completed',
  createdBy:      ''   as string,
  assignedTo:     ''   as string,
  dueAfter:       ''   as string,
  dueBefore:      ''   as string,
  sortField:      'due_date' as 'name' | 'due_date' | 'status',
  sortDir:        'asc'      as 'asc' | 'desc',
};

export type TaskConfig = typeof TASK_CONFIG_DEFAULT;

export interface CustomActionLink {
  label: string;
  url: string;
  icon?: string;
}

export const ACTION_CONFIG_DEFAULT = {
  enabledActions: ['rules', 'time', 'calendar', 'note'] as string[],
  customLinks:    [] as CustomActionLink[],
};

export type ActionConfig = typeof ACTION_CONFIG_DEFAULT;

export const CALENDAR_CONFIG_DEFAULT = {
  query:          '' as string,
  eventTypes:     [] as string[],
  createdBy:      '' as string,
  calendarName:   '' as string,
  dateAfter:      '' as string,
  dateBefore:     '' as string,
};

export type CalendarConfig = typeof CALENDAR_CONFIG_DEFAULT;

export interface CostTargetConfig {
  id: string;
  name: string;
  type: 'TimeEntry' | 'ExpenseEntry' | 'all';
  categoryFilter?: string;
  userFilter?: string;
  dateAfter?: string;
  dateBefore?: string;
  targetBudget: number;
}

export const COST_CONFIG_DEFAULT = {
  feesBudget:      35000 as number,
  expensesBudget:  15000 as number,
  targets: [
    { id: 'partner', name: 'Partner Hours', type: 'TimeEntry' as const, categoryFilter: 'Partner Hours', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 15000 },
    { id: 'associate', name: 'Associate Hours', type: 'TimeEntry' as const, categoryFilter: 'Associate Hours', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 10000 },
    { id: 'paralegal', name: 'Paralegal Hours', type: 'TimeEntry' as const, categoryFilter: 'Paralegal Hours', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 6000 },
    { id: 'research', name: 'Legal Research', type: 'TimeEntry' as const, categoryFilter: 'Research', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 4000 },
    { id: 'filing', name: 'Filing Fees', type: 'ExpenseEntry' as const, categoryFilter: 'Filing', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 1500 },
    { id: 'service', name: 'Process Server', type: 'ExpenseEntry' as const, categoryFilter: 'Server', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 800 },
    { id: 'transcripts', name: 'Transcripts', type: 'ExpenseEntry' as const, categoryFilter: 'Transcript', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 3500 },
    { id: 'expert', name: 'Expert Witness', type: 'ExpenseEntry' as const, categoryFilter: 'Expert', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 7500 },
    { id: 'travel', name: 'Travel / Misc', type: 'ExpenseEntry' as const, categoryFilter: 'Travel', userFilter: '', dateAfter: '', dateBefore: '', targetBudget: 1700 },
  ] as CostTargetConfig[]
};

export type WidgetConfig = Partial<Omit<DocConfig, 'sortField'> & Omit<TaskConfig, 'sortField'> & ActionConfig & CalendarConfig & typeof COST_CONFIG_DEFAULT> & { sortField?: DocConfig['sortField'] | TaskConfig['sortField']; showArchived?: boolean; authorNameFilter?: string };
